import { NiN } from '@visiba/national-identity-number';

export function validateNin(countryCode: keyof NiN.Implementations, value: string | null) {
	return value != null && NiN.validate(countryCode, value.trim());
}

export function validateRequired(value: string | null): boolean {
	if (value != null && value.trim() != '') {
		return true;
	}

	return false;
}
